// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__390Cq","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3HKoq"};